import React from 'react';

const Category = ({ category, activeNote, updateNoteCategories }) => {
    const selected = () => {
        return activeNote.categories.some((current_category) => current_category === category.id);
    }

    return (
        <span
            className={`categories-selector__category${selected() === true ? ' selected' : ''}`}
            onClick={() => updateNoteCategories(activeNote.id, category.id)}
        >
            {category.name}
        </span>
    )
}

export default Category;